<template>
  <v-expansion-panels
    v-model="panel"
    class="mt-3"
  >
    <v-expansion-panel>
      <v-expansion-panel-header color="third">
        <template #actions>
          <v-icon color="white">
            $expand
          </v-icon>
        </template>
        <v-card-title class="third white--text font-weight-bold">
          <span class="ml-2">{{ title }}</span>
        </v-card-title>
        <v-spacer />
        <div class="d-flex justify-end">
          <div v-if="add && canUserPerformAction" style="width: 50px;">
            <v-icon size="28" color="white" class="justify-end" @click.stop="add(null)">mdi-plus</v-icon>
          </div>
          <div style="width: 50px;">
            <v-icon size="28" color="white" @click.stop="downloadTableContent">mdi-export</v-icon>
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          :headers="headers"
          :items="tableItems"
          height="350"
        >
          <!-- Generic slots that can be used with useTemplate flag in headers -->
          <template v-for="(header, index) in headers" #[`item.${header.value}`]="{ item }">
            <slot v-if="header.useTemplate" :name="`item.${header.value}`" :item="item"></slot>
            <span v-else :key="`normal-item-${index}`">{{ item[header.value] }}</span>
          </template>

          <!-- Mandatory slot for HorseTable -->
          <template #item.actions="{ item }">
            <v-icon v-if="canUserPerformAction" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon v-if="canUserPerformAction" @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { downloadCSV } from '../../../helpers/utils';
import store from '@/store';

export default {
  props: {
    headers: {
      type: Array,
      default () {
        return [];
      }
    },
    title: {
      type: String,
      default: null
    },
    tableItems: {
      type: Array,
      default () {
        return [];
      }
    },
    add: {
      type: Function,
      default: null
    },
    deleteItem: {
      type: Function,
      default: null
    },
    editItem: {
      type: Function,
      default: null
    }
  },
  setup (props) {
    const panel = ref(0);

    const data = ref(JSON.parse(JSON.stringify(props.tableItems)));

    data.value.map(horse => {
      delete horse.uuid;
      return horse;
    });

    const downloadTableContent = () => {
      downloadCSV([{ headers: props.headers, data: data.value }], props.title);
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    return { panel, downloadTableContent, canUserPerformAction };
  }
};
</script>

<style>
  .v-data-table__wrapper > table{
    table-layout: fixed;
  }

  .v-expansion-panel-header{
    max-height: 64px;
  }
</style>
